
var MOON_APPAREL_PRODUCT_APP = function (pc) {
  'use strict';
  var app = {},
  imageHandler = {},
  productImageHandler,
  collectionImageHandler,
  memoizer,
  addSwatchesToPage,
  newSwatch,
  productContainer = pc,
  availableColors = [],
  availableSizes = [],
  availableQty = 0,/* no array needed */
  handle = '', 
  variants = [],
  selectedColor = '',
  selectedSize = null,
  selectedQty = 0,
  selectedVariant = {},
  cartButton = {},
  tryToMakeSelection,
  activateCartButton,
  deactivateCartButton,
  outOfStockButton,
  handleSizes,
  populateQuantity,
  productNotAvailableFunction,
  currentCartFunction,
  addMoonProductToCartFunction,
  addFail,
  addSuccess;
  
  productNotAvailableFunction = function () {
        if(selectedQty == 0 && selectedSize === null) {
            alert('Please select a size and quantity.');
        } else if (selectedQty === 0 ) {
           alert('Please specify a quantity.');
        } else if (selectedSize === null) {
            alert('Please select a size.');
        }     
  };

  currentCartFunction = productNotAvailableFunction;
  
  function moneyFormater (pennies) {
        return '$' + (pennies / 100);
    }

  memoizer = function (arr) {
     var memfunct = function (col){ 
            var i = 0,
            found = false;
            for(i = 0 ; i < arr.length ; i += 1) {
                if(arr[i] === $.trim(col) ) { found = true; }
            }
            if(!found) { arr.push($.trim(col) ); }
        };
      return memfunct;
  };

  function updateCartStatus (data) {
        var i = 0,
        frmHTML = '<table id="cart-tabe" style="border-collapse: collapse;">',
        prodName = '',
        cents = '',
        item_txt = 'item',
        cart_txt = 'cart',
        qty_txt = 'qty',
        price_txt = 'price',
        addtcart_txt = 'ADD TO CART',
        added_txt = 'ADDED',
        checkout_txt = 'view cart',
        fontsize = 9;
        
       

        if(MOON_APPAREL_FRENCH_USER === true ) {
            item_txt = 'articles';
            price_txt = 'prix';
            cart_txt = 'panier';
            qty_txt = 'qt&eacute;';
            addtcart_txt = 'ajouter au panier';
            added_txt = 'AJOUT&Eacute;E';
            checkout_txt = 'VOIR MON PANIER';
            fontsize = 8;
        }

        frmHTML += '<tr style="text-align: left;"><th style="border-bottom: 1px solid #aaa;" width="60px">' + qty_txt + '</th>' + 
        '<th style="border-bottom: 1px solid #aaa;" width="260px">' + item_txt + 
        '</th><th style="border-bottom: 1px solid #aaa; width: 100px" >' + price_txt +'</th></tr>';
        for(i = 0; i < data.items.length; i += 1) {
          frmHTML += '<tr><td>' + data.items[i].quantity + '</td><td>' + data.items[i].title.split(' - ')[0] + '</td><td>' +  moneyFormater(data.items[i].price) + '</td></tr>';
          
        }
        frmHTML += '<tr>' +
            '<td style="border-top: solid 1px #aaa; text-align: right; padding-right: 22px;" colspan="2" >TOTAL</td>' +
            '<td style="border-top: solid 1px #aaa;  align: left;">' +   moneyFormater( data.total_price )  + '</td>' +
            '</tr>' +
            '<tr>' +
            '<td></td>' +
            '<td colspan="2" align="right">' +
            '<a class="checkinout" href="/cart">' + checkout_txt + '</a>' +
            '</td>' +
            '</tr>';
        frmHTML += '</table>';
        $('#popwrap').html(frmHTML);
            cartButton.html(added_txt + ' &#10004;');
            cartButton.css( { background : '#a6f2ab' } );
            if(MOON_APPAREL_FRENCH_USER === true) {
                 cartButton.css( { fontSize : '9pt', lineHeight: '16pt' } );
            }
              $("#cart-data").html( '<span id="cart-data">' + 
                               '<!--[if lt IE 8 ]><a href="/cart"><![endif]-->' + cart_txt + 
                               '&nbsp;(' +  data.item_count + ')' +
                               '<!--[if lt IE 8 ]></a><![endif]-->' + 
                               '</span>');
           
      }

  addFail = function (jqXHR, textStatus, errorThrown) { };

  addSuccess = function (jqXHR, textStatus, errorThrown) {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        async: true,
        cache: false,
        dataType: 'json',
        success: updateCartStatus  
      });      
    };

  addMoonProductToCartFunction = function () {
        $.ajax({ 
          type: 'POST',
          url: '/cart/add.js',
          async: true,
          cache: false,
          data: 'quantity=' + selectedQty + '&id=' + selectedVariant.id,
          dataType: 'json',
          error: addFail,
          success: addSuccess
        });
    };

  activateCartButton = function () {
        currentCartFunction = addMoonProductToCartFunction;
        cartButton.css({
            color : '#777',
            border : 'solid 1px #aaa',
            background : 'white'
        });
         if(MOON_APPAREL_FRENCH_USER === true) {
            cartButton.text('AJOUTER AU PANIER');
            cartButton.css({fontSize : '7.5pt', paddingTop : '1px', paddingBottom : '1px', height : '20px', lineHeight : '7.5pt' } );
        } else {
            cartButton.text('ADD TO CART');
            cartButton.css({ lineHeight : '9pt' } );
        }
        cartButton.addClass('active-cart');
    };

    deactivateCartButton = function () {
        currentCartFunction = productNotAvailableFunction;
        cartButton.css({
            color : '#ddd',
            border : 'solid 1px #ddd',
            background : 'white'
        });
        if(MOON_APPAREL_FRENCH_USER === true) {
            cartButton.text('AJOUTER AU PANIER');
        } else {
            cartButton.text('ADD TO CART');
        }
       
        cartButton.removeClass('active-cart');
    };
    
    outOfStockButton = function () {
        currentCartFunction = productNotAvailableFunction;
        cartButton.css({
            color : 'white',
            border : 'solid 1px #bb0000',
            background: '#ff5566',
            fontSize : '7.5pt'
        });
         if(MOON_APPAREL_FRENCH_USER === true) {
            cartButton.text('en rupture de stock');
        } else {
            cartButton.text('out of stock');
        }
        cartButton.removeClass('active-cart');
    };

  tryToMakeSelection = function () {
    var success = false,
          c = 0;
          if( selectedQty < 1 ) { return false; }
          if(selectedSize !== null ) {
              for(c = 0; c < variants.length; c += 1) {
                    if(variants[c].size === selectedSize && variants[c].color === selectedColor) {
                        success = true;
                        selectedVariant = variants[c];
                        availableQty = selectedVariant.qty;
                        break;
                    }
              }
          }
          
          if(success === true) {
                activateCartButton();
                if(availableQty < 1) {
                    outOfStockButton();
                }
          } else {
              if(selectedSize !== null) {
                  outOfStockButton();
              } else {
                  deactivateCartButton();
              }
          }
  };

  handleSizes = function () {
    var sizeContainer = productContainer.find(".size-list"),
    sizechart_txt = 'size chart',
    sizelisties,
    prodTipe = productContainer.find(".hiddentype").val(),
    i = 0;
    
    if(MOON_APPAREL_FRENCH_USER === true) {
      sizechart_txt = 'guide de tailles';
    }
        for(i = 0 ; i < availableSizes.length ; i += 1) {
            $('<li class="size-selection" data-value="' + availableSizes[i] + '"><p class="inner-size-select">' + availableSizes[i] + '</p></li>').appendTo(sizeContainer);
        }
        
        if( prodTipe !== 'Accessories') {
             $('<li class="size-selection" ><p class="inner-size-chart"><a href="/pages/sizing-chart">' +  sizechart_txt + '</a></p></li>').appendTo(sizeContainer);
        }
        //$('<li class="size-selection" ><p class="inner-size-chart"><a href="/pages/sizing-chart">' +  sizechart_txt + '</a></p></li>').appendTo(sizeContainer);

        sizelisties = productContainer.find('.size-selection');
        sizelisties.not('.selected-size').css({ display: 'none' });
                
        sizelisties.each(function(){
            $(this).click( function (e) {
                if( $(this).data('value') === undefined ) {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open('/pages/sizing-chart', '', 'width=1000,height=800,scrollbars=1,menubar=no,status=no,toolbar=no,top=200,left=200');
                    return;
                }
                sizelisties.each( function () { $(this).removeClass('selected-size'); });
                $(this).addClass('selected-size');
                selectedSize = $.trim( $(this).data('value') );
                tryToMakeSelection();
            });
        });
        
        if(availableSizes.length < 2) {
            var theOnlySize = $(sizelisties[1]);
            sizelisties.css({ display : 'block' });
            theOnlySize.addClass('selected-size');
            selectedSize = availableSizes[0];
            tryToMakeSelection();
            sizelisties.not('.selected-size').css({  display : 'none' });
           
        }
            
        sizelisties.filter(':odd').css({ borderTop: 'none' });
        sizelisties.filter(':even').css({ borderTop: 'none' });
            
        sizeContainer.mouseover(function(){
            sizelisties.css({ display : 'block' });
        });

        sizeContainer.mouseout(function(){
            sizelisties.not('.selected-size').css({  /* visibility : 'hidden' */ display : 'none' });
        });
       
    };

    populateQuantity = function () {
        var numOfItems = 6,
        g = 0,
        qtyContainer = productContainer.find('.qty-list'),
        qtylisties;
          
        for(g = 1; g < numOfItems ; g += 1 ) {
              qtyContainer.append('<li class="qty-selection" data-value="' + g + '"><p class="inner-qty-select">' + g + '</p></li>');
        }

        qtylisties = productContainer.find(".qty-selection");
        qtylisties.not('.selected-qty').css({ display : 'none' }); 
        qtyContainer.mouseover( function () {
            qtylisties.css({ display : 'block' });
        });
            
        qtylisties.filter(':odd').css({ borderTop: 'none' });
        qtylisties.filter(':even').css({ borderTop: 'none' });
                 
        qtyContainer.mouseout( function () {
            qtylisties.not('.selected-qty').css({ display : 'none' /* visibility : 'hidden' */ });
        });

        qtylisties.each(function(){
            $(this).click( function (e) {
                qtylisties.each( function () {
                    $(this).removeClass('selected-qty');
                });
                $(this).addClass('selected-qty');
                selectedQty = $.trim( $(this).data('value') );
                tryToMakeSelection();
            });
        });
            
    };


  productImageHandler = function () {
    var handler = {},
    imageElems = $('.product-image'),
    imageTainer1 = $('.prod-img-1'),
    imageTainer2 = $('.prod-img-2'),
    imageSets = [],
    displayImage,
    rollOverImage,
    currentSet,
    frontView = true,
    makeImageSets,
    shade = $('.shade'),
    detailBtn = $('#detail-view-btn'),
    closeBtn = $('#x'),
    detailImgTainer = $('.detail-img-tainer'),
    detailImage = new Image(),
    switchImageTimer = null,
    transitioning = false,
    unavailable_info = $('.unavailable-info'),
    unavailable_swatch = $('.unavailable-swatch'),
    displayDetail;
    
    displayDetail = function (e) {
        e.preventDefault();
        detailBtn.find('.inner').css({background: '#646464'});
        shade.css({display: 'block'});
        shade.animate({opacity: '0.8'}, 400);
        detailImgTainer.css({display: 'block'});
        detailImgTainer.animate({opacity: '1'}, 400);
    };

     function codeBlue () {
            unavailable_info.css({ opacity: '0', display: 'none' });  
            $('#view-row').css({visibility : 'visible', height: '30'});
            $('#detail-row').css({visibility : 'visible' });
       }

       function codeRed () {
           unavailable_info.css({ opacity: '1', display: 'block' });  
           unavailable_swatch.removeClass();
           unavailable_swatch.addClass('unavailable-swatch');
           unavailable_swatch.addClass(selectedColor);
           clearTimeout( switchImageTimer );
          $('#view-row').css({visibility : 'hidden' , height: '0'});
          $('#detail-row').css({visibility : 'hidden' , height: '0'});
       }

    function hideDetail (e) {
      e.preventDefault();
            shade.animate({opacity: '0' },400, function(){
                shade.css({ display: 'none' });
            });
           detailImgTainer.animate({opacity: '0' },400, function(){
                detailImgTainer.css({ display: 'none' });
            });
            detailBtn.find('.inner').css({ background: 'none' });
        }

        function checkSpecificity () {
          var locationString = window.location.href,
          appendage = '',
          swrap = {},
          i = 0;
          if( locationString.search('#!') > -1) {
              appendage = locationString.split('/').pop();
              currentSet = imageSets[appendage];
              for(i = 0 ; i < availableColors.length ; i += 1) {
                  productContainer.find('.swatch-wrap').css({ border : '1px solid transparent' });
              }
               
               swrap = productContainer.find('.swatch-wrap')[appendage];
               $(swrap).css({ border : 'solid 1px #646464' });
               selectedColor = availableColors[appendage];
               if(currentSet.available === false) {  
                  codeRed();
               } 
          } else {
              currentSet = imageSets[0];
              selectedColor = availableColors[0];
          }
        
        }

    function updateInfoMessage () {
      var msg = '',
      viewmsg = '',
      front_txt = 'FRONT VIEW',
      back_txt = 'BACK VIEW';

      if(MOON_APPAREL_FRENCH_USER === true ) {
        front_txt = 'VUE DEVANT';
        back_txt = 'VUE DE DOS';
      }

      if(frontView === true) {
        viewmsg = front_txt;
      } else {
       viewmsg = back_txt;
      }
      msg = selectedColor + ' - ' + viewmsg;
      if(currentSet.available === true) {
        $('.view-status').text(msg);
      } else {
        $('.view-status').text(selectedColor);
      }
      $('.unavailable-name').text(selectedColor);
    }

    makeImageSets = function () {
           var preloadedImage1,
            preloadedImage2,
            preloadedImage3,
            i = 0;
            for(i = 0; i < availableColors.length; i+= 1) {
                  preloadedImage1 = new Image();
                  preloadedImage2 = new Image();
                  preloadedImage3 = new Image();
                if((i * 3) >= imageElems.length) {
                preloadedImage1.src = '//cdn.shopify.com/s/files/1/0159/4830/t/3/assets/unavailable.jpg?v=1351533387';  
                    imageSets.push({ 
                        img1 : '//cdn.shopify.com/s/files/1/0159/4830/t/3/assets/unavailable.jpg?v=1351533387', 
                        img2 : '//cdn.shopify.com/s/files/1/0159/4830/t/3/assets/unavailable.jpg?v=1351533387', 
                        detail : '//cdn.shopify.com/s/files/1/0159/4830/t/3/assets/unavailable.jpg?v=1351533387', 
                        available : false });
              } else {
                    
                preloadedImage1.src = $(imageElems[i * 3]).data('imagesrc');
                    preloadedImage2.src = $(imageElems[(i * 3) + 1]).data('imagesrc');
                    preloadedImage3.src = $(imageElems[(i * 3) + 2]).data('imagesrc');
                     imageSets.push({ 
                         img1 : $(imageElems[( i * 3 )]).data('imagesrc'), 
                         img2 : $(imageElems[ (( i * 3 ) + 1) ]).data('imagesrc'),
                         detail : $(imageElems[ (( i * 3 ) + 2) ]).data('imagesrc'),
                         available : true } ); 
              }
            }
        };

        function handleImages () {
           var viewbtn1 = $("#view-1-btn"),
           viewbtn2 = $("#view-2-btn"),
           showImage1,
           showImage2,
           showImage3,
           loadImage = new Image();
           
            //currentSet = imageSets[0];
            displayImage =  currentSet.img1;
            rollOverImage =  currentSet.img2;
            
            if(currentSet.available === false) {  codeRed(); } 
            
            loadImage.src = currentSet.img1;
            loadImage.onload = function () {
                $('#loadwheel').css({opacity: '0'});
                imageTainer1.animate({ opacity : '1' }, 800);
                switchImageTimer = setInterval(function(){
                if(frontView === true) {
                        showImage2();
                    } else {
                        showImage1();
                    }
                }, 4000);
            };
          

            imageTainer1.css({ background : 'url(' + displayImage + ')'});
            imageTainer2.css({ background : 'url(' + rollOverImage + ')'});
            
            detailImage.src = currentSet.detail;
            detailImgTainer.append(detailImage);
            
            showImage1 = function () {
               imageTainer1.animate({ opacity : '1' }, 800);
               imageTainer2.animate({ opacity : '0' }, 800,
               function () { transitioning = false; }); 
               viewbtn1.find('.inner').css({background: '#c2c2c2'});
               viewbtn2.find('.inner').css({ background : 'none' });
               frontView = true;
                transitioning = true;
               updateInfoMessage();
            };
            
            showImage2 = function () {
                imageTainer1.animate({ opacity: '0' }, 800);
                imageTainer2.animate({ opacity: '1' }, 800, function () {
                    transitioning = false;
                });
                viewbtn2.find('.inner').css({background: '#c2c2c2'});
                viewbtn1.find('.inner').css({ background : 'none' });
                frontView = false;
                transitioning = true;
                updateInfoMessage();
               
            };
            
            viewbtn1.click( function (e) {
                clearTimeout( switchImageTimer );
                e.preventDefault();
                if(transitioning === false) {
                    showImage1();
                }
                
            });
            
             viewbtn2.click( function (e) {
                clearTimeout( switchImageTimer );
                e.preventDefault();
                if( transitioning === false) {
                    showImage2();
                }
            });
        }

    handler.swatchClickHandler = function (b) {
      return function (e) {
        var oldImage = displayImage,
        tempImage,
        swrap,
        i = 0;

        e.preventDefault();

        if(availableColors.length < 2) { return; }          
                if(transitioning === true) { return; }

                currentSet = imageSets[b];
                if(currentSet.available === true) {  codeBlue(); }
                if(typeof currentSet === 'object') {
                    displayImage =  currentSet.img1;
                    rollOverImage =  currentSet.img2;
                    detailImage.src = currentSet.detail;
                    transitioning = true;
                    if(frontView) {
                      imageTainer2.css({ background : 'url(' + displayImage + ')'} );
                      imageTainer1.animate({  opacity : '0'},300);

                      imageTainer2.animate({  opacity : '1'},300, function () {
                        imageTainer1.css({ background : 'url(' + rollOverImage + ')'});
                        tempImage = imageTainer1;
                        imageTainer1 = imageTainer2;
                        imageTainer2 = tempImage;
                        transitioning = false;
                      });
                    } else {
                      imageTainer1.css({ background : 'url(' + rollOverImage + ')'} );
                      imageTainer2.animate({ opacity : '0'},300);

                      imageTainer1.animate({ opacity : '1'},300, function () {
                        imageTainer2.css({ background : 'url(' + displayImage + ')'});
                        tempImage = imageTainer1;
                        imageTainer1 = imageTainer2;
                        imageTainer2 = tempImage;
                        transitioning = false;
                      });
                    }
                }

               
                productContainer.find('.swatch-wrap').css({ border : 'solid 1px transparent' });
              
                swrap = productContainer.find('.swatch-wrap')[b];
                $(swrap).css({ border : 'solid 1px #646464' });
                selectedColor = $(this).data('value');
                tryToMakeSelection();
                updateInfoMessage();
                if(currentSet.available === false) { codeRed(); }
            };

    };

    handler.swatchMouseOver = function () { 
      var vtainer = $('.swatch-view');
      vtainer.stop();
      vtainer.removeClass();
      vtainer.addClass('swatch-view');
      vtainer.addClass($(this).data('value').replace('/','-'));
      vtainer.animate({ opacity : '1' }, 400);
    };

    handler.swatchMouseOut = function () {
      var vtainer = $('.swatch-view');
      vtainer.stop();
      vtainer.animate({  opacity : '0' }, 400);
    };

    handler.initialize = function () {
      makeImageSets();
      checkSpecificity();
      updateInfoMessage();
      handleImages();
    };

    closeBtn.click( hideDetail );
    shade.click( hideDetail );
    detailBtn.click( displayDetail );
    $('.detailtrigger').click( displayDetail );

    return handler;
  };

  collectionImageHandler = function () {
    var handler = {},
    fadeOutSwatch,
    displayImage,
    currentSet,
    images = productContainer.find(".prod-img"),
    varSets = [],
    rollOverImage,
    imageTainer = productContainer.find('.img-wrap'),
    oldLink = productContainer.find('.product-linker').attr('href'),
    oldProdName = productContainer.find('.prod-name a').text();

    function makeImageSets () {
          var placeHolder = new Image(),
          totalImages = availableColors.length * 2,
          loadedImages = 0,
          loadImg,
          i = 0;
          
          placeHolder.src = '//cdn.shopify.com/s/files/1/0159/4830/t/3/assets/Image-Not-Available.jpg?v=1351533362';
           for(i = 0; i < availableColors.length; i+= 1) {
                if((i * 3) >= images.length) {
                    varSets.push({ img1 : placeHolder, 
                    img2 : placeHolder, available : false });
                    
                } else {
                     varSets.push({ img1 : $(images[( i * 3 )]), 
                     img2 : $(images[ (( i * 3 ) + 1) ]) , available : true } );
                }
               
         }
        loadImg = new Image();
        loadImg.src = $(varSets[0].img1).attr('src');
        loadImg.onload = function () {
             productContainer.find('.loading').css({ opacity: '0' });
             $(images[0]).animate({  opacity : '1' }, 200);
         };
         
      }

      function handleImages () {
            currentSet = varSets[0];
            displayImage =  currentSet.img1;
            rollOverImage =  currentSet.img2;
          
          if(currentSet.available === false) {
              imageTainer.css({background: 'url(' + displayImage.src + ')' });
          } 

            imageTainer.mouseover(function () {
                  $(displayImage).stop();
                  $(rollOverImage).stop();
                  $(displayImage).animate({ opacity : '0'}, 500);
                  $(rollOverImage).animate({ opacity : '1' }, 500);
            });
      
            imageTainer.mouseout(function () {
                  $(displayImage).stop();
                  $(rollOverImage).stop();
                  $(rollOverImage).animate({ opacity : '0'}, 500);
                  $(displayImage).animate({ opacity : '1'}, 500);
            });
       }

    fadeOutSwatch = function () {
      var vtainer = productContainer.find('.big-swatch-view');
      vtainer.stop();
      vtainer.animate({  opacity : '0' }, 400 );
      productContainer.find('.prod-name a').text(oldProdName);
        };

    handler.swatchClickHandler = function (b) {

      return function (e) {
              var oldImage = displayImage,
              i = 0,
              swatchwraps =  productContainer.find('.swatch-wrap'),
              swrap = {};
              e.preventDefault();

              if(availableColors.length < 2) { return; }
 
              currentSet = varSets[b];                    
              productContainer.find('.product-linker').attr('href', oldLink + '/#!/' + b);
              productContainer.find('.linker-two').attr('href', oldLink + '/#!/' + b);

              if(typeof currentSet === 'object') {
                  displayImage =  currentSet.img1;
                  rollOverImage =  currentSet.img2;
                  $(oldImage).animate({ opacity : '0'}, 500);
                  $(displayImage).animate({ opacity : '1'}, 500);
              }
                                
              if(currentSet.available === false) {
                  imageTainer.css({background: 'url(' + displayImage.src + ')' });
              } else {
                  imageTainer.css({background: 'none' });
              } 
                              
              swatchwraps.css({ border : 'solid 1px transparent' });
             

              swrap = productContainer.find('.swatch-wrap')[b];
              $(swrap).css({ border : 'solid 1px #646464' });
              selectedColor = $(this).data('value');

              tryToMakeSelection();
              fadeOutSwatch();
          };

    };
    
    handler.swatchMouseOver = function () {
         var vtainer = productContainer.find('.big-swatch-view');
         vtainer.stop();
         vtainer.removeClass();
         vtainer.addClass('big-swatch-view');
         vtainer.addClass($(this).data('value').replace('/','-'));
         vtainer.animate({ opacity : '1' }, 400);
         productContainer.find('.prod-name a').text($(this).data('value'));
    };
    handler.swatchMouseOut = function () {
        var vtainer = productContainer.find('.big-swatch-view');
        vtainer.stop();
        vtainer.animate({  opacity : '0' }, 400 );
         productContainer.find('.prod-name a').text(oldProdName);
    };

    handler.initialize = function () {
      makeImageSets();
      handleImages();
      selectedColor = availableColors[0];
    };

    return handler;
  };

  app.setUpImageHandler = function (pageType) {
    switch(pageType) {
      case 'product':
        imageHandler = productImageHandler();
      break;
      case 'collection':
        imageHandler = collectionImageHandler();
      break;
    }
  };

  /* send to this function 
  the three jQuery objects 
  representing the twitter, 
  facebook and pinterest 
  share buttons */
  app.productSharer = function (twitter_button,facebook_button, pinterest_button) {

    pinterest_button.click(function(e) {
        var imageNumber = 0,
        i = 0,
        medImages = $('.med-img'),
        imageToShare ='',
        shareURL = 'http://pinterest.com/pin/create/button/';
        for(i = 0; i < availableColors.length; i+= 1) {
            if(availableColors[i] === selectedColor) {
                imageNumber = i;
                imageToShare = $(medImages[ i * 3]).data('imagesrc');  
            }
        }
           shareURL += '?url=' + $(this).data('url');
           shareURL += '&media=' + imageToShare;
           shareURL += '&description' + $(this).data('description');
          
           e.preventDefault();
            window.open(shareURL,'pinterest', 'width=600,height=600,menubar=no,status=no,toolbar=no,top=20,left=20' );
        });//end pinterest handler
        twitter_button.click( function (e) {
            var twitterurl = '',
            tite = '';
            tite = $.trim( $('.prod-name').text() );
             e.preventDefault();
             twitterurl = 'https://twitter.com/share' +
                        '?original_referer=http%3A%2F%2Fmoon-apparel.myshopify.com' +
                        '&source=tweetbutton' +
                        '&text=' + 'Moon Apparel ' + tite +
                        '&url=' + window.location;
                        
            window.open(twitterurl, 'twitter', 'width=600,height=600,menubar=no,status=no,toolbar=no,top=20,left=20');
        } );

        facebook_button.click( function (e) { 
            e.preventDefault();
            var shareObj = {},
            serc = $(this).data('img'),
            tite = '';
            tite = $.trim( $('.prod-name').text() );
            shareObj.method = 'feed';
            shareObj.name = 'Moon Apparel';
            shareObj.link = window.location;
            shareObj.picture = serc;
            shareObj.picture = shareObj.picture.split('?')[0];
            shareObj.caption = tite;
            FB.ui(shareObj, function () {
            
            });
        });
  };

  newSwatch = function (b) {
    var swatch = {},
    swatchClick;

    swatch = $('<div class="swatch-wrap" data-value="' +  availableColors[b] + '"><a href="#" class="color-swatch ' +  availableColors[b].replace('/','-') + '"></a></div>');

    swatch.click( imageHandler.swatchClickHandler(b) )
    .mouseover( imageHandler.swatchMouseOver )
    .mouseout( imageHandler.swatchMouseOut );

    return swatch;

  };

  addSwatchesToPage = function () {
    var i = 0,
    swatch = {},
    container = productContainer.find(".swatch-container"),
    firstswrap;

    for(i = 0; i < availableColors.length; i += 1) {
      swatch = newSwatch(i);
      swatch.appendTo(container);
    }

    firstswrap = productContainer.find('.swatch-wrap')[0];
        $(firstswrap).css({ border : 'solid 1px #707070' });
  };


    app.handleDescriptionNav = function () {
        var leftButton = $('#nav-left-arrow'),
        rightButton = $('#nav-right-arrow'),
        firstElipse = $('#nav-elipse-1'),
        secondElipse = $('#nav-elipse-2'),
        thirdElipse = $('#nav-elipse-3'), 
        descriptionTainer = $('.prod-description-inner'),
        currentDesc = 1;
           
           function showTainer1 () {
               descriptionTainer.animate({marginLeft : '0px' }, 400);
               currentDesc = 1;
               firstElipse.css({ background: '#c2c2c2' });
               secondElipse.css({ background: 'none' });
               thirdElipse.css({ background: 'none' });
           }
           
           function showTainer2 () {
               descriptionTainer.stop();
               descriptionTainer.animate({marginLeft : '-230px' }, 400);
               currentDesc = 2;
                firstElipse.css({ background: 'none' });
               secondElipse.css({ background: '#c2c2c2' });
               thirdElipse.css({ background: 'none' });
           }
           
           function showTainer3 () {
               descriptionTainer.stop();
                descriptionTainer.animate({marginLeft : '-460px' }, 400);
                currentDesc = 3;
                 firstElipse.css({ background: 'none' });
               secondElipse.css({ background: 'none' });
               thirdElipse.css({ background: '#c2c2c2' });
           }
           
           firstElipse.click(function (e) {
                e.preventDefault();
                showTainer1();
           });
           
           secondElipse.click(function (e) {
                e.preventDefault();
                showTainer2();
           });
           
            thirdElipse.click(function (e) {
                e.preventDefault();
                showTainer3();
           });
           
           leftButton.click( function (e) {
                e.preventDefault();
                 switch(currentDesc) {
                    case 1:
                        showTainer3();
                    break;
                    case 2:
                        showTainer1();
                    break;
                    case 3: 
                        showTainer2();
                    break;
                    default:
                    
                }
           });
           
           rightButton.click( function (e) {
                e.preventDefault();
                switch(currentDesc) {
                    case 1:
                        showTainer2();
                    break;
                    case 2:
                        showTainer3();
                    break;
                    case 3: 
                        showTainer1();
                    break;
                    default:
                    
                }
           });

           firstElipse.css({ background: '#c2c2c2' });
       };

       app.initialize = function () {
          var colorAdder = memoizer(availableColors),
          sizeAdder = memoizer(availableSizes),
          swatches = {},
          i = 0;

          //grab the variant info 
          swatches = productContainer.find(".prod-info");
          //handle
          handle =  productContainer.find('.prod-handle').data('handle');
          //cart button
          cartButton =  productContainer.find('.cart-button');

          //populate variants array 
          swatches.each( function () {
            var verient = {
                  id : $(this).data("variantid"),
                  sku : $(this).data("variantsku"),
                  qty : $(this).data("variantqty"),
                  color : $.trim( $(this).data("productinfo").split(" ")[0] ),
                  size : $.trim( $(this).data("productinfo").split(" ")[2])
              };
            variants.push(verient);
          });

          //populate availableColors array
          for( i = 0; i < swatches.length ; i += 1) {
              colorAdder( $(swatches[i]).data("productinfo").split(" ")[0] );
          }

          //populate availableSizes array 
          for( i = 0; i < swatches.length ; i += 1) {
            sizeAdder(  $(swatches[i]).data("productinfo").split(" ")[2] );
          }
      };

    app.buildPage = function () {
      (function(h, obj){
            if(MOON_APPAREL_CANADIAN_USER === true) {
                 $.getJSON('/products/'+ h +'.js', function(prod) {
                    obj.html( moneyFormater(prod.price) );
                 });
            } else {
               obj.html('');
            }
        }(handle, productContainer.find(".moneybags") ));

        addSwatchesToPage();
        handleSizes();
        populateQuantity();
        imageHandler.initialize();
        cartButton.click( function (e) {
                e.preventDefault();
                currentCartFunction();
        });
    };

  return app;
};